<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode" @onChange="onChange">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="!viewMode" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import reportDetail from "./detail";

export default {
  mixins: [detailMixin, reportDetail],
  data() {
    return {
      breadcrumb: [
        { name: "报单管理", path: `/customer/CReportOrder` },
        { name: "报单列表", path: `/customer/CReportOrder` },
        { name: "添加报单" },
      ],
    };
  },
  methods: {
    getKeys() {
      const arr = [
        'id',
        'c_id',
        'p_id',
        'pricing_id',
        'quantity',
        'coaddress',
        'drman',
        'drtel',
        'enaddress',
        'enman',
        'ertel',
        'predict_loading_date',
        'predict_unloading_date',
      ]
      return arr
    },
  },
  created() {
    const { user_group_id } = this.user
    if (user_group_id != 12) {
      this.formCtrl.splice(0, 0, {
        label: "客户名称",
        keyName: "custom",
        err: "请填写客户名称",
        type: "text",
        className: 'block',
        disabled: true,
      })
    }
    this.formCtrl.splice(this.formCtrl.length - 1, 0, {
      label: "提交日期",
      keyName: "submitted_at",
      err: "请选择提交日期",
      type: "date",
      disabled: true,
    })
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
